import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

export function usePayerHistoryResources(payerId: string): AuditLogResource[] {
  return useMemo(
    () => [
      {
        resourceType: ListAuditLogsFilterParameterResourceTypeEq.PAYER,
        resourceId: payerId
      }
    ],
    [payerId]
  );
}
